"use client";

import Link from 'next/link';
import Image from "next/image";
import React, { useEffect, useState } from "react";
import TeamCarousel from '../components/TeamCarousel'; 
import OurRecentWork from '../components/OurRecentWork';
import ContactForm from '../components/ContactForm';
import HomeHeroSlider from "../components/HomeHeroSlider";
import AOS from "aos";
import "aos/dist/aos.css";

const Page = () => {
  const newLocal = "btn btn-primary";

  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);

  const blogsPerSlide = 3;
  const [slides, setSlides] = useState([]);

  // Initialize AOS
  useEffect(() => {
    AOS.init({ 
      once: true,
      duration: 500,
      easing: 'ease-in-out',
      delay: 100,
      offset: 50,
      disable: false,
      startEvent: 'DOMContentLoaded',
      useClassNames: false,
      disableMutationObserver: false,
      debounceDelay: 50,
      throttleDelay: 99,
    });
    
    console.log("API Base URL:", process.env.NEXT_PUBLIC_API_BASE_URL);

    const fetchBlogs = async () => {
      try {
        // const res = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/api/blogs/recent?page=1&limit=6`);
        const res = await fetch(`/api/blogs/recent?page=1&limit=6`);
        const data = await res.json();
        console.log("Fetched blogs data:", data);
        if (data.success) {
          setBlogs(data.blogs);
        }
      } catch (err) {
        console.error("Error fetching blogs:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  // Generate slides after blog load
  useEffect(() => {
    if (blogs.length > 0) {
      const grouped = [];
      for (let i = 0; i < blogs.length; i += blogsPerSlide) {
        grouped.push(blogs.slice(i, i + blogsPerSlide));
      }
      setSlides(grouped);
    }
  }, [blogs]);

  // Refresh AOS when content changes
  useEffect(() => {
    if (!loading && slides.length > 0) {
      // Use a longer timeout to ensure DOM is fully updated
      const timeoutId = setTimeout(() => {
        AOS.refresh();
      }, 300);

      return () => clearTimeout(timeoutId);
    }
  }, [loading, slides]);

  // Initialize Locomotive Scroll (Only in Browser)
  // useEffect(() => {
  //   if (typeof window !== "undefined") {
  //     import("locomotive-scroll").then((LocomotiveScrollModule) => {
  //       const scroll = new LocomotiveScrollModule.default({
  //         el: document.querySelector('[data-scroll-container]'),
  //         smooth: true,
  //       });
  //     });
  //   }
  // }, []);
  useEffect(() => {
  const el = document.querySelector('[data-scroll-container]');

  if (!el) return; // ✅ error fix

  import("locomotive-scroll").then((LocomotiveScrollModule) => {
    new LocomotiveScrollModule.default({
      el: el,
      smooth: true,
    });
  });
}, []);

  const totalSlides = slides.length;

  // const handlePrev = () => {
  //   if (currentSlide > 0) {
  //     setCurrentSlide(currentSlide - 1);
  //     // Refresh AOS after slide change with delay
  //     setTimeout(() => {
  //       AOS.refresh();
  //     }, 600); // Wait for transition to complete
  //   }
  // };
  const handlePrev = () => {
    setCurrentSlide((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
    setTimeout(() => {
      AOS.refresh();
    }, 600);
  };

  // const handleNext = () => {
  //   if (currentSlide < totalSlides - 1) {
  //     setCurrentSlide(currentSlide + 1);
  //     // Refresh AOS after slide change with delay
  //     setTimeout(() => {
  //       AOS.refresh();
  //     }, 600); // Wait for transition to complete
  //   }
  // };

const handleNext = () => {
    setCurrentSlide((prev) => (prev === totalSlides - 1 ? 0 : prev + 1));
    setTimeout(() => {
      AOS.refresh();
    }, 600);
  };
  return (
    // <div>
    <div data-scroll-container>
      <div className="main-banner">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="container">
              <div className="row h-100 justify-content-center align-items-center">
                <div className="col-lg-5">
                  <div className="hero-content">
                    <h1 className='mt-[100px]' data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">Digital Marketing &amp; Web Solutions</h1>
                    <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="500" data-aos-once="true">Do you know what it takes to grow your business online? <br></br> Do you want to?</p>
                    <Link className={newLocal} data-aos="fade-up" data-aos-delay="300" data-aos-duration="500" data-aos-once="true" href={"/contact"}>Get Started</Link>
                  </div>
                </div>
                <div className="col-lg-6 offset-lg-1">
                  <div className="banner-image" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                    <Image src="/man.svg" alt="man" loading="lazy" width="371" height="400" decoding="async" data-nimg="1" className="animate__animated animate__fadeInDown animate__delay-0.1s" />
                    <Image src="/code.svg" alt="code" loading="lazy" width="174" height="111" decoding="async" data-nimg="1" className="animate__animated animate__fadeInUp animate__delay-0.1s" />
                    <Image src="/carpet.svg" alt="carpet" loading="lazy" width="510" height="293" decoding="async" data-nimg="1" className="animate__animated animate__fadeInLeft animate__delay-0.1s" />
                    <Image src="/bin.svg" alt="bin" loading="lazy" width="86" height="112" decoding="async" data-nimg="1" className="animate__animated animate__zoomIn animate__delay-0.1s" />
                    <Image src="/book.svg" alt="book" loading="lazy" width="78" height="74" decoding="async" data-nimg="1" className="animate__animated animate__bounceIn animate__delay-0.1s" />
                    <Image src="/dekstop.svg" alt="dekstop" loading="lazy" width="105" height="147" decoding="async" data-nimg="1" className="animate__animated animate__fadeInDown animate__delay-0.1s" />
                    <Image src="/dot.svg" alt="dot" loading="lazy" width="94" height="70" decoding="async" data-nimg="1" className="animate__animated animate__zoomIn animate__delay-0.1s" />
                    <Image src="/flower-top-big.svg" alt="flower-top-big" loading="lazy" width="78" height="291" decoding="async" data-nimg="1" className="animate__animated animate__fadeInUp animate__delay-0.1s" />
                    <Image src="/flower-top1.svg" alt="flower-top" loading="lazy" width="53" height="87" decoding="async" data-nimg="1" className="animate__animated animate__rotateIn animate__delay-0.1s" />
                    <Image src="/keyboard.svg" alt="keyboard" loading="lazy" width="121" height="73" decoding="async" data-nimg="1" className="animate__animated animate__fadeInUp animate__delay-0.1s" />
                    <Image src="/pen.svg" alt="pen" loading="lazy" width="42" height="77" decoding="async" data-nimg="1" className="animate__animated animate__zoomIn animate__delay-0.1s" />
                    <Image src="/table2.svg" alt="table" loading="lazy" width="380" height="342" decoding="async" data-nimg="1" className="animate__animated animate__zoomIn animate__delay-0.1s" />
                    <Image src="/tea-cup.svg" alt="tea-cup" loading="lazy" width="44" height="104" decoding="async" data-nimg="1" className="animate__animated animate__fadeInLeft animate__delay-0.1s" />
                    <Image src="/headphone.svg" alt="headphone" loading="lazy" width="62" height="62" decoding="async" data-nimg="1" className="animate__animated animate__rollIn animate__delay-0.1" />
                    <Image src="/main-pic.svg" alt="main-pic" loading="lazy" width="580" height="560" decoding="async" data-nimg="1" className="animate__animated animate__fadeInUp animate__delay-0.1" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="shape1"><Image src="/shape1.svg" alt="shape" loading="lazy" width="202" height="202" decoding="async" data-nimg="1" /></div>
        <div className="shape2 rotateme"><Image src="/shape2.svg" alt="shape" loading="lazy" width="22" height="22" decoding="async" data-nimg="1" /></div>
        <div className="shape3"><Image src="/shape3.svg" alt="shape" loading="lazy" width="28" height="28" decoding="async" data-nimg="1" /></div>
        <div className="shape4"><Image src="/shape4.svg" alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" /></div>
        <div className="shape5"><Image src="/shape5.svg" alt="shape" loading="lazy" width="182" height="146" decoding="async" data-nimg="1" /></div>
        <div className="shape6 rotateme"><Image src="/shape4.svg" alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" /></div>
        <div className="shape7"><Image src="/shape4.svg" alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" /></div>
        <div className="shape8 rotateme"><Image src="/shape2.svg" alt="shape" loading="lazy" width="22" height="22" decoding="async" data-nimg="1" /></div>
      </div>

      <div className="boxes-area pb-80">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-3 col-md-6">
              <Link href={"/website-design-and-development-services"}>
                <div className="single-box" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                  <div className="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
                      <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
                      <line x1="6" y1="6" x2="6.01" y2="6"></line>
                      <line x1="6" y1="18" x2="6.01" y2="18"></line>
                    </svg>
                  </div>
                  <h3>Website Design & Development</h3>
                  <p>Startup, Business & eCommerce Website online store</p>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-md-6">
              <Link href={"/digital-marketing-services"}>
                <div className="single-box bg-f78acb" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500" data-aos-once="true">
                  <div className="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="16 18 22 12 16 6"></polyline>
                      <polyline points="8 6 2 12 8 18"></polyline>
                    </svg>
                  </div>
                  <h3>Digital Marketing Services</h3>
                  <p>Grow Your Business Online includes SMO, SEO, advertising and more.</p>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-md-6">
              <Link href={"/ecommerce-marketplaces-services"}>
                <div className="single-box bg-c679e3" data-aos="fade-up" data-aos-delay="300" data-aos-duration="500" data-aos-once="true">
                  <div className="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                  </div>
                  <h3>eCommerce Marketplace Services</h3>
                  <p>Catalogue Services, Increase your sale on Amazon, Flipkart.</p>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-md-6">
              <Link href={"/mobile-app-development"}>
                <div className="single-box bg-eb6b3d" data-aos="fade-up" data-aos-delay="400" data-aos-duration="500" data-aos-once="true">
                  <div className="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="6" y1="3" x2="6" y2="15"></line>
                      <circle cx="18" cy="6" r="3"></circle>
                      <circle cx="6" cy="18" r="3"></circle>
                      <path d="M18 9a9 9 0 0 1-9 9"></path>
                    </svg>
                  </div>
                  <h3>Mobile App Development</h3>
                  <p>Custom Android and iOS apps with seamless performance and user experience.</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="services-area ptb-80 bg-f7fafd">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6 col-md-12 services-content">
              <div className="ml-about-content">
                <h2 data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">Digital Marketing Services</h2>
                <div className="bar" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true"></div>
                <p data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">Looking to boost your brand's visibility? engage your target audience, and drive business growth. Partner with us today!</p>
              </div>
              <div className="row services-content" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <div className="col-lg-6 col-md-6">
                  <Link href={"/social-media-marketing-services"}>
                    <div className="box" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                        <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
                        <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
                      </svg>
                      Branding & Marketing
                    </div>
                  </Link>
                </div>
                <div className="col-lg-6 col-md-6">
                  <Link href={"/social-media-marketing-services"}>
                    <div className="box">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="2" y1="12" x2="22" y2="12"></line>
                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                      </svg>
                      Google Analytics
                    </div>
                  </Link>
                </div>
                <div className="col-lg-6 col-md-6">
                  <Link href={"/social-media-marketing-services"}>
                    <div className="box">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                        <polyline points="13 2 13 9 20 9"></polyline>
                      </svg>
                      Programmatic Advertising
                    </div>
                  </Link>
                </div>
                <div className="col-lg-6 col-md-6">
                  <Link href={"/social-media-marketing-services"}>
                    <div className="box">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                        <polyline points="17 6 23 6 23 12"></polyline>
                      </svg>
                      Strategy & Research
                    </div>
                  </Link>
                </div>
                <div className="col-lg-6 col-md-6">
                  <Link href={"/social-media-marketing-services"}>
                    <div className="box">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                      </svg>
                      Modern Keyword Analysis
                    </div>
                  </Link>
                </div>
                <div className="col-lg-6 col-md-6">
                  <Link href={"/social-media-marketing-services"}>
                    <div className="box">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                        <line x1="8" y1="21" x2="16" y2="21"></line>
                        <line x1="12" y1="17" x2="12" y2="21"></line>
                      </svg>
                      Monthly Report
                    </div>
                  </Link>
                </div>
                <div className="col-lg-6 col-md-6">
                  <Link href={"/social-media-marketing-services"}>
                    <div className="box">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                      </svg>
                      Conversion Rate
                    </div>
                  </Link>
                </div>
                <div className="col-lg-6 col-md-6">
                  <Link href={"/social-media-marketing-services"}>
                    <div className="box">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
                      </svg>
                      Website Ranking
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 services-right-image" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
              <Image src="/book-self.svg" alt="book-self" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true" loading="lazy" width="139" height="139" decoding="async" data-nimg="1" />
              <Image src="/box.svg" alt="box" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="150" data-aos-duration="500" data-aos-once="true" loading="lazy" width="420" height="251" decoding="async" data-nimg="1" />
              <Image src="/chair.svg" alt="chair" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500" data-aos-once="true" loading="lazy" width="67" height="127" decoding="async" data-nimg="1" />
              <Image src="/cloud.svg" alt="cloud" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="250" data-aos-duration="500" data-aos-once="true" loading="lazy" width="158" height="140" decoding="async" data-nimg="1" />
              <Image src="/cup.svg" alt="cup" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="300" data-aos-duration="500" data-aos-once="true" loading="lazy" width="82" height="93" decoding="async" data-nimg="1" />
              <Image src="/flower-top.svg" alt="flower" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="350" data-aos-duration="500" data-aos-once="true" loading="lazy" width="27" height="78" decoding="async" data-nimg="1" />
              <Image src="/head-phone.svg" alt="head-phone" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="400" data-aos-duration="500" data-aos-once="true" loading="lazy" width="30" height="29" decoding="async" data-nimg="1" />
              <Image src="/monitor.svg" alt="monitor" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="450" data-aos-duration="500" data-aos-once="true" loading="lazy" width="70" height="99" decoding="async" data-nimg="1" />
              <Image src="/mug.svg" alt="mug" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="500" data-aos-duration="500" data-aos-once="true" loading="lazy" width="16" height="20" decoding="async" data-nimg="1" />
              <Image src="/table.svg" alt="table" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="550" data-aos-duration="500" data-aos-once="true" loading="lazy" width="162" height="149" decoding="async" data-nimg="1" />
              <Image src="/tissue.svg" alt="tissue" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="600" data-aos-duration="500" data-aos-once="true" loading="lazy" width="26" height="42" decoding="async" data-nimg="1" />
              <Image src="/water-bottle.svg" alt="water-bottle" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="650" data-aos-duration="500" data-aos-once="true" loading="lazy" width="14" height="37" decoding="async" data-nimg="1" />
              <Image src="/wifi.svg" alt="wifi" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="700" data-aos-duration="500" data-aos-once="true" loading="lazy" width="55" height="71" decoding="async" data-nimg="1" />
              <Image src="/cercle-shape.svg" alt="shape" className="animate__animated animate__fadeInUp animate__delay-0.1s bg-image rotateme" data-aos="fade-up" data-aos-delay="750" data-aos-duration="500" data-aos-once="true" loading="lazy" width="524" height="518" decoding="async" data-nimg="1" />
              <Image src="/main-pic2.svg" alt="main-pic" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="800" data-aos-duration="500" data-aos-once="true" loading="lazy" width="342" height="396" decoding="async" data-nimg="1" />
            </div>
          </div>
        </div>
      </div>

      <div className="services-area ptb-80">
        <div className="container">
          <div className="row h-100 justify-content-center align-items-center">
            <div className="col-lg-6 col-md-12 services-left-image" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
              <Image src="/big-monitor.svg" alt="big-monitor" className="animate__animated animate__fadeInUp animate__delay-0.1s" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true" loading="lazy" width="252" height="149" decoding="async" data-nimg="1" />
              <Image src="/creative.svg" alt="creative" className='animate__animated animate__fadeInUp animate__delay-0.1s' data-aos="fade-up" data-aos-delay="150" data-aos-duration="500" data-aos-once="true" loading="lazy" width="88" height="94" decoding="async" data-nimg="1" />
              <Image src="/developer.svg" alt="developer" className='animate__animated animate__fadeInUp animate__delay-0.1s' data-aos="fade-up" data-aos-delay="200" data-aos-duration="500" data-aos-once="true" loading="lazy" width="149" height="230" decoding="async" data-nimg="1" />
              <Image src="/flower-top-red.svg" alt="flower-top" className='animate__animated animate__fadeInUp animate__delay-0.1s' data-wow-delay="0.6s" data-aos="fade-up" data-aos-delay="250" data-aos-duration="500" data-aos-once="true" loading="lazy" width="127" height="203" decoding="async" data-nimg="1" />
              <Image src="/small-monitor.svg" alt="small-monitor" className='animate__animated animate__fadeInUp animate__delay-0.1s' data-aos="fade-up" data-aos-delay="300" data-aos-duration="500" data-aos-once="true" loading="lazy" width="109" height="106" decoding="async" data-nimg="1" />
              <Image src="/small-top.svg" alt="small-top" className='animate__animated animate__fadeInUp animate__delay-0.1s' data-aos="fade-up" data-aos-delay="350" data-aos-duration="500" data-aos-once="true" loading="lazy" width="56" height="82" decoding="async" data-nimg="1" />
              <Image src="/table-red.svg" alt="table" className='animate__animated animate__fadeInUp animate__delay-0.1s' data-aos="fade-up" data-aos-delay="400" data-aos-duration="500" data-aos-once="true" loading="lazy" width="337" height="138" decoding="async" data-nimg="1" />
              <Image src="/target.svg" alt="target" className='animate__animated animate__fadeInUp animate__delay-0.1s' data-aos="fade-up" data-aos-delay="450" data-aos-duration="500" data-aos-once="true" loading="lazy" width="91" height="96" decoding="async" data-nimg="1" />
              <Image src="/cercle-shape.svg" alt="shape" className='animate__animated animate__fadeInUp animate__delay-0.1s bg-image rotateme' data-aos="fade-up" data-aos-delay="500" data-aos-duration="500" data-aos-once="true" loading="lazy" width="524" height="518" decoding="async" data-nimg="1" />
              <Image src="/main-pic-red.svg" alt="main-pic" className='animate__animated animate__fadeInUp animate__delay-0.1s' data-aos="fade-up" data-aos-delay="550" data-aos-duration="500" data-aos-once="true" loading="lazy" width="418" height="378" decoding="async" data-nimg="1" />
            </div>
            <div className="col-lg-6 col-md-12 services-content">
              <div className="ml-about-content">
                <h2 data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">Web Design &amp; Development</h2>
                <div className="bar ml-about-content" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true"></div>
                <p data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">Looking for premium disigning and development services to take your brand to the next level? Our expert team delivers innovative solutions tailored to your unique needs.</p>
              </div>
              <div className="row services-content">
                <div className="col-lg-6 col-md-6">
                  <Link href="/ecommerce-website-development-services">
                    <div className="box" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="9" cy="21" r="1"></circle>
                        <circle cx="20" cy="21" r="1"></circle>
                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                      </svg>
                      eCommerce Development
                    </div>
                  </Link>
                </div>
                <div className="col-lg-6 col-md-6">
                  <Link href="/website-design-and-development-services">
                    <div className="box" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="3" y1="9" x2="21" y2="9"></line>
                        <line x1="9" y1="21" x2="9" y2="9"></line>
                      </svg>
                      Responsive Design
                    </div>
                  </Link>
                </div>
                <div className="col-lg-6 col-md-6">
                  <Link href="/website-design-and-development-services">
                    <div className="box" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="16 18 22 12 16 6"></polyline>
                        <polyline points="8 6 2 12 8 18"></polyline>
                      </svg>
                      React Web Development
                    </div>
                  </Link>
                </div>
                <div className="col-lg-6 col-md-6">
                  <Link href="/mobile-app-development">
                    <div className="box" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
                        <line x1="12" y1="18" x2="12.01" y2="18"></line>
                      </svg>
                      Android &amp; iOS Apps Development
                    </div>
                  </Link>
                </div>
                <div className="col-lg-6 col-md-6">
                  <Link href="/website-design-and-development-services">
                    <div className="box" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="16 18 22 12 16 6"></polyline>
                        <polyline points="8 6 2 12 8 18"></polyline>
                      </svg>
                      PHP Laravel Web Development
                    </div>
                  </Link>
                </div>
               
                <div className="col-lg-6 col-md-6">
                  <Link href="/ui-ux-design-services">
                    <div className="box" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="19" y1="5" x2="5" y2="19"></line>
                        <circle cx="6.5" cy="6.5" r="2.5"></circle>
                        <circle cx="17.5" cy="17.5" r="2.5"></circle>
                      </svg>
                      UX/UI Design
                    </div>
                  </Link>
                </div>
                <div className="col-lg-6 col-md-6">
                  <Link href="/wordpress-shopify-development">
                    <div className="box" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                      </svg>
                      Wordpress & Shopify Design
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="features-area ptb-80 bg-f7fafd">
        <div className="container">
          <div className="section-title pb-50 ">
            <h2 data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">Our Services</h2>
            <div className="bar" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true"></div>
            <p data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true"> Our services can take your business to the next level. From strategy to execution, trust us to deliver exceptional results. </p>
          </div>
          <div className="row pb-80">
            <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
              <div className="single-features" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <div className="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="3"></circle>
                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                  </svg>
                </div>
                <h3 data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                  <Link href={"/website-design-and-development-services"}>Website Design & Development</Link>
                </h3>
                <p data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">Looking for top-notch Website Design & Development services to create a stunning online presence? Our experts can bring your vision to life!</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500" data-aos-once="true">
              <div className="single-features" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <div className="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <h3 data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                  <Link href={"/seo-services"}>Search Engine Optimization (SEO)</Link>
                </h3>
                <p data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">Looking for expert Search Engine Optimization services to boost your website's visibility and ranking on search engines.</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="300" data-aos-duration="500" data-aos-once="true">
              <div className="single-features" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <div className="icon bg-c679e3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="7" height="7"></rect>
                    <rect x="14" y="3" width="7" height="7"></rect>
                    <rect x="14" y="14" width="7" height="7"></rect>
                    <rect x="3" y="14" width="7" height="7"></rect>
                  </svg>
                </div>
                <h3 style={{textTransform:"none"}} data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                  <Link href={"/ecommerce-website-development-services"} style={{textTransform:"none"}}>eCommerce Website Development</Link>
                </h3>
                <p>Looking for eCommerce Website Development services to grow your business online? We are develop custom online store that drives sales and boosts your brand's online presence.</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="400" data-aos-duration="500" data-aos-once="true">
              <div className="single-features" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <div className="icon bg-c679e3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                  </svg>
                </div>
                <h3><Link href={"/social-media-marketing-services"}>Social Media Marketing (SMM)</Link></h3>
                <p>Looking to boost your online presence? Our Social Media Marketing services will help you reach your target audience effectively and grow your brand.</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="500" data-aos-duration="500" data-aos-once="true">
              <div className="single-features" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <div className="icon bg-eb6b3d">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                    <line x1="12" y1="22.08" x2="12" y2="12"></line>
                  </svg>
                </div>
                <h3><Link href={"/mobile-app-development"}>Mobile App Development</Link></h3>
                <p>Looking for top-notch Mobile App Development services? Our team of experts will create cutting-edge applications to help your business growth.</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="600" data-aos-duration="500" data-aos-once="true">
              <div className="single-features" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <div className="icon bg-eb6b3d">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                  </svg>
                </div>
                <h3><Link href={"/social-media-optimization-services"}>Social Media Optimization (SMO)</Link></h3>
                <p>Our Social Media Optimization services can help you reach a wider audience and increase engagement.</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="600" data-aos-duration="500" data-aos-once="true">
              <div className="single-features" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <div className="icon bg-eb6b3d">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                  </svg>
                </div>
                <h3><Link href={"/ecommerce-marketplace-website-services"} style={{textTransform:"none"}}>eCommerce marketplace Website</Link></h3>
                <p>We are develop custom e-Commerce Marketplace Website with multy vendor store.</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="500" data-aos-duration="500" data-aos-once="true">
              <div className="single-features" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <div className="icon bg-eb6b3d">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                    <line x1="12" y1="22.08" x2="12" y2="12"></line>
                  </svg>
                </div>
                <h3><Link href={"/ecommerce-marketplaces-services"}>Marketplace Services (Amazon, Flipkart)</Link></h3>
                <p>Our Marketplace Services can help your business grow with increased visibility, reach, and sales.</p>
              </div>
            </div>
        
            <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="500" data-aos-duration="500" data-aos-once="true">
              <div className="single-features" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <div className="icon bg-eb6b3d">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                    <line x1="12" y1="22.08" x2="12" y2="12"></line>
                  </svg>
                </div>
                <h3><Link href={"/graphic-design-services"}>Graphic Design Services</Link></h3>
                <p>Graphic design services play a vital role in helping businesses create a strong visual presence and connect with their target audience effectively.</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="500" data-aos-duration="500" data-aos-once="true">
              <div className="single-features" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <div className="icon bg-eb6b3d">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                    <line x1="12" y1="22.08" x2="12" y2="12"></line>
                  </svg>
                </div>
                <h3><Link href={"/whatsapp-marketing-services"}>WhatsApp Marketing Services</Link></h3>
                <p>Our WhatsApp Marketing Services to boost your brand's visibility and engage with customers in a personalized and interactive way.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="funfacts-area pb-50">
        <div className="container">
          <div className="section-title" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
            <h2 data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">We always try to understand users expectation</h2>
            <div className="bar" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true"></div>
            <p data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">We are passionate about helping businesses thrive in the digital world.</p>
          </div>
          <div className="row funnum">
            <div className="col-lg-3 col-md-3 col-6" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
              <div className="funfact" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <h3>97%</h3>
                <p>Client Retention</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-6" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
              <div className="funfact" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <h3>5 Year</h3>
                <p>Year of experience</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-6" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
              <div className="funfact" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <h3>95%</h3>
                <p>Certified Professionals</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-6" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
              <div className="funfact" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <h3>100%</h3>
                <p>Happy Clients</p>
              </div>
            </div>
          </div>
          <div className="map-bg" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
            <Image src="/map.svg" alt="map" loading="lazy" width="910" height="443" decoding="async" data-nimg="1" />
          </div>
        </div>
      </div>

      <OurRecentWork />

      <section className="feedback-area pt-80 bg-#FFFFFF00">
        <div className="container">
          <div className="section-title">
            <h2 data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">What Users Saying</h2>
            <div className="bar" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true"></div>
            <p data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">From doubt to belief, vision to website—that's the Eratec Solution difference. We build high-performing websites that turn ideas into success. Don't take our word for it—see what our clients say!</p>
            <TeamCarousel/>
          </div>
        </div>
        <div className="shape1"><Image src="/shape1.svg" alt="shape" loading="lazy" width="202" height="202" decoding="async" data-nimg="1" /></div>
        <div className="shape2 rotateme"><Image src="/shape2.svg" alt="shape" loading="lazy" width="22" height="22" decoding="async" data-nimg="1" /></div>
        <div className="shape3"><Image src="/shape3.svg" alt="shape" loading="lazy" width="28" height="28" decoding="async" data-nimg="1" /></div>
        <div className="shape4"><Image src="/shape4.svg" alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" /></div>
        <div className="shape5"><Image src="/shape5.svg" alt="shape" loading="lazy" width="182" height="146" decoding="async" data-nimg="1" /></div>
        <div className="shape6 rotateme"><Image src="/shape4.svg" alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" /></div>
        <div className="shape7"><Image src="/shape4.svg" alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" /></div>
        <div className="shape8 rotateme"><Image src="/shape2.svg" alt="shape" loading="lazy" width="22" height="22" decoding="async" data-nimg="1" /></div>
      </section>

      {/* Our Clients Section - Fixed AOS */}
      <div className="ready-to-talk">
        <div className="container">
          <h3 data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">Our Clients</h3>
          <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="500" data-aos-once="true">Our clients inspire us to innovate, create, and craft experiences that bring genuine smiles to their faces.</p>
        </div>
      </div>

      <div className="partner-area partner-section pb-150 mb-50">
        <div className="container">
          <h5 data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">More than 250+ businesses and organizations work with us</h5>
          <div className="partner-inner" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500" data-aos-once="true">
            <div className="row justify-content-center">
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                <Link href="" target="_blank">
                  <Image src="/orientalTrimexLogo.svg" alt="partner" height={100} width={100} />
                  <Image src="/orientalTrimexLogo.svg" alt="partner" height={100} width={100} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="150" data-aos-duration="500" data-aos-once="true">
                <Link href="https://www.thathardwarestore.com/" target="_blank">
                  <Image src="/white-Logo-hardware-store-2.svg" alt="partner" height={100} width={100} />
                  <Image src="/white-Logo-hardware-store-2.svg" alt="partner" height={100} width={100} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500" data-aos-once="true">
                <Link href="https://blazeremedies.in/" target="_blank">
                  <Image src="/blaze-ramedies.svg" alt="partner" height={60} width={100} />
                  <Image src="/blaze-ramedies.svg" alt="partner" height={60} width={100} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="250" data-aos-duration="500" data-aos-once="true">
                <Link href="https://wannaink.com/" target="_blank">
                  <Image src="/Wanna-Ink-Logo.svg" alt="partner" height={100} width={100} />
                  <Image src="/Wanna-Ink-Logo.svg" alt="partner" height={100} width={100} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="300" data-aos-duration="500" data-aos-once="true">
                <Link href="https://www.godsgraceivfcenter.com/" target="_blank">
                  <Image src="/Logo-GODS-GRACE-IVF-Center.svg" alt="partner" height={60} width={100} />
                  <Image src="/Logo-GODS-GRACE-IVF-Center.svg" alt="partner" height={60} width={100} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="350" data-aos-duration="500" data-aos-once="true">
                <Link href="https://www.myratrendz.com/" target="_blank">
                  <Image src="/Mayra-Trendz-Logo.svg" alt="partner" height={60} width={60} />
                  <Image src="/Mayra-Trendz-Logo.svg" alt="partner" height={60} width={60} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="400" data-aos-duration="500" data-aos-once="true">
                <Link href="https://www.bariahouselifting.com/" target="_blank">
                  <Image src="/BariaHouse-logo.svg" alt="partner" height={100} width={100} />
                  <Image src="/BariaHouse-logo.svg" alt="partner" height={100} width={100} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="450" data-aos-duration="500" data-aos-once="true">
                <Link href="#" target="_blank">
                  <Image src="/home-heart-brand.svg" alt="partner" height={100} width={100} />
                  <Image src="/home-heart-brand.svg" alt="partner" height={100} width={100} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="500" data-aos-duration="500" data-aos-once="true">
                <Link href="https://www.sanvi.net/" target="_blank">
                  <Image src="/Sanvi-Logo.svg" alt="partner" height={60} width={100} />
                  <Image src="/Sanvi-Logo.svg" alt="partner" height={60} width={100} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="550" data-aos-duration="500" data-aos-once="true">
                <Link href="https://www.kalanishtha.com/" target="_blank">
                  <Image src="/kalanishtha-logo.svg" alt="partner" height={60} width={200} />
                  <Image src="/kalanishtha-logo.svg" alt="partner" height={60} width={200} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="600" data-aos-duration="500" data-aos-once="true">
                <Link href="https://broachmachinetools.com/" target="_blank">
                  <Image src="/maheen-broaches.svg" alt="partner" height={60} width={100} />
                  <Image src="/maheen-broaches.svg" alt="partner" height={60} width={100} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="650" data-aos-duration="500" data-aos-once="true">
                <Link href="https://theuniquemugs.com/" target="_blank">
                  <Image src="/TheUniqueMugs-Logo.svg" alt="partner" height={100} width={150} />
                  <Image src="/TheUniqueMugs-Logo.svg" alt="partner" height={100} width={150} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="700" data-aos-duration="500" data-aos-once="true">
                <Link href="https://b2c.kaushalinternational.com/" target="_blank">
                  <Image src="/Kaushal-International-Logo.svg" alt="partner" height={100} width={150} />
                  <Image src="/Kaushal-International-Logo.svg" alt="partner" height={100} width={150} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="750" data-aos-duration="500" data-aos-once="true">
                <Link href="https://www.algnutrastore.com/" target="_blank">
                  <Image src="/algnutra-store-Logo.svg" alt="partner" height={100} width={150} />
                  <Image src="/algnutra-store-Logo.svg" alt="partner" height={100} width={150} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="800" data-aos-duration="500" data-aos-once="true">
                <Link href="https://www.kanhapolyfab.com/" target="_blank">
                  <Image src="/Kanha-polyfab-logo.svg" alt="partner" height={100} width={150} />
                  <Image src="/Kanha-polyfab-logo.svg" alt="partner" height={100} width={150} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="850" data-aos-duration="500" data-aos-once="true">
                <Link href="https://friendspackermovers.com/" target="_blank">
                  <Image src="/packersMovers.svg" alt="partner" height={50} width={80} />
                  <Image src="/packersMovers.svg" alt="partner" height={50} width={80} />
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="900" data-aos-duration="500" data-aos-once="true">
                <Link href="https://starpaper.co.in/plantation/" target="_blank">
                  <Image src="/Star-Paper-Logo.svg" alt="partner" height={100} width={150} />
                  <Image src="/Star-Paper-Logo.svg" alt="partner" height={100} width={150} />
                </Link>
              </div>
               <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
            <Link href="https://herbalpowerindia.com/" target="_blank">
              <Image src="/herbalpowerlogo.png" alt="Herbal Power India" height={100} width={100} />
              <Image src="/herbalpowerlogo.png" alt="Herbal Power India" height={100} width={100} />
            </Link>
          </div>
            <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500" data-aos-once="true">
            <Link href="https://addlyssalon.com/" target="_blank">
              <Image src="/Logo-4.svg" alt="Addly's De Salon" height={100} width={100} />
              <Image src="/Logo-4.svg" alt="Addly's De Salon" height={100} width={100} />
            </Link>
          </div>
          <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="300" data-aos-duration="500" data-aos-once="true">
            <Link href="https://www.kickdrink.ae/" target="_blank">
          <Image src="/kicksdrinklogo.png" alt="Kick Drink UAE" height={100} width={100} />
         <Image src="/kicksdrinklogo.png" alt="Kick Drink UAE" height={100} width={100} />
        </Link>
         </div>
         <div className="col-lg-2 col-md-3 col-6" data-aos="fade-up" data-aos-delay="400" data-aos-duration="500" data-aos-once="true">
            <Link href="https://www.homeheartbrands.com/" target="_blank">
          <Image src="/hhblogo.png" alt="Home Heart Brands USA" height={100} width={100} />
          <Image src="/hhblogo.png" alt="Home Heart Brands USA" height={100} width={100} />
          </Link>
         </div>
          </div>
            </div>
          </div>
        </div>
    


      {/* Our Blogs Section - Fixed AOS */}
      <div data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
        <section className="feedback-area">
          <div className="container">
            <div className="blog-section-title section-title">
              <h2 data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">Our Blogs</h2>
              <div className="bar" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500" data-aos-once="true"></div>
              <p className="pb-10" data-aos="fade-up" data-aos-delay="300" data-aos-duration="500" data-aos-once="true">{"Don't miss out on our latest posts!"}</p>
              
              {/* <div className="blog-area pt-15 pb-10"> */}
              <div className="blog-area">
                <div className="shape1"><Image src="/shape1.svg" alt="shape" loading="lazy" width="202" height="202" decoding="async" data-nimg="1" /></div>
                <div className="shape2 rotateme"><Image src="/shape2.svg" alt="shape" loading="lazy" width="22" height="22" decoding="async" data-nimg="1" /></div>
                <div className="shape3"><Image src="/shape3.svg" alt="shape" loading="lazy" width="28" height="28" decoding="async" data-nimg="1" /></div>
                <div className="shape4"><Image src="/shape4.svg" alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" /></div>
                <div className="shape5"><Image src="/shape5.svg" alt="shape" loading="lazy" width="182" height="146" decoding="async" data-nimg="1" /></div>
                <div className="shape6 rotateme"><Image src="/shape4.svg" alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" /></div>
                <div className="shape7"><Image src="/shape4.svg" alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" /></div>
                <div className="shape8 rotateme"><Image src="/shape2.svg" alt="shape" loading="lazy" width="22" height="22" decoding="async" data-nimg="1" /></div>

                <div className="blog-container" data-aos="fade-up" data-aos-delay="400" data-aos-duration="500" data-aos-once="true">
                  {loading ? (
                    <div className="flex justify-between gap-6" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                      {[...Array(3)].map((_, i) => (
                        <div key={i} className="w-full sm:w-1/2 md:w-1/3 animate-pulse bg-white p-4 rounded shadow">
                          <div className="h-40 bg-gray-300 rounded mb-4"></div>
                          <div className="h-4 bg-gray-300 rounded mb-2 w-3/4"></div>
                          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="blog-slider-container" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                      <div className="relative flex">
                        {/* <div
                               onClick={currentSlide === 0 ? null : handlePrev}
                                style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                 width: '40px',
                                height: '40px',
                               borderRadius: '50%',
                               background: currentSlide === 0 ? '#ddd' : '#6b21a8',
                               color: '#fff',
                               cursor: currentSlide === 0 ? 'not-allowed' : 'pointer',
                                flexShrink: 0,
                                fontSize: '20px',
                              alignSelf: 'center',
                                }}
                                  >
                               &#8592;
                            </div> */}
                            {/*left arrow */}
                     	    {/* <div
                                // onClick={currentSlide === 0 ? null : handlePrev}
                                onClick={() => handlePrev()}
                                className={`swiper-button-prev ${
                                  currentSlide === 0 ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''
                                }`}
                                data-aos="fade-right"
                                data-aos-delay="200"
                                data-aos-duration="500"
                                data-aos-once="true"
                              >
                                </div>  */}
                               <div
                                    onClick={() => handlePrev()}
                                    className="swiper-button-prev"
                                    data-aos="fade-right"
                                    data-aos-delay="200"
                                    data-aos-duration="500"
                                    data-aos-once="true"
                                  >
                                  </div>
                          
                                    {/* Right Arrow */}
                                  {/* <div
                                      onClick={currentSlide === totalSlides - 1 ? null : handleNext}
                                     style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      width: '40px',
                                     height: '40px',
                                    borderRadius: '50%',
                                     background: currentSlide === totalSlides - 1 ? '#ddd' : '#6b21a8',
                                    color: '#fff',
                                     cursor: currentSlide === totalSlides - 1 ? 'not-allowed' : 'pointer',
                                      flexShrink: 0,
                                      fontSize: '20px',
                                     alignSelf: 'center',
                                    }}
                                    >
                                    &#8594;
                                 </div> */}

                        
                        <div className="overflow-hidden mx-4 flex-1">
                          <div
                            className="flex transition-transform duration-500 ease-in-out"
                            style={{
                              transform: `translateX(-${currentSlide * (100 / totalSlides)}%)`,
                              width: `${100 * totalSlides}%`,
                            }}
                          >
                            {slides.map((group, idx) => (
                              <div
                                key={idx}
                                className="flex-shrink-0 px-4"
                                style={{ width: `${100 / totalSlides}%` }}
                              >
                                <div className="flex justify-between gap-6">
                                  {group.map((blog, blogIdx) => (
                                    <div 
                                      key={blog.id} 
                                      className="w-full sm:w-1/2 md:w-1/3"
                                      data-aos="fade-up" 
                                      data-aos-delay={`${100 + (blogIdx * 100)}`} 
                                      data-aos-duration="500" 
                                      data-aos-once="true"
                                    >
                                      <div className="single-blog-post bg-white shadow rounded overflow-hidden">
                                        <div className="blog-image relative">
                                          <Link href={`/blog/${blog.slug}`}>
                                            <Image
                                              // src={`${process.env.NEXT_PUBLIC_API_BASE_URL}/uploads/${blog.image}`}
                                              // src={blog.image 
                                              //       ? `https://www.eratecsolution.com/uploads/${blog.image}`
                                              //          : `https://placehold.co/900x400?text=No+Image`
                                              //            }
                                              src={blog.image 
                                                  ? `${process.env.NEXT_PUBLIC_BASE_URL || 'http://localhost:3000'}/uploads/${blog.image}`
                                                  : `https://placehold.co/900x400?text=No+Image`
                                                    }                                
                                              alt={blog.title}
                                              width={900}
                                              height={400}
                                              className="rounded-t"
                                            />
                                          </Link>
                                          <div className="date absolute bottom-2 left-2 bg-white text-sm px-2 py-1 rounded flex items-center gap-1 shadow">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              strokeWidth="2"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            >
                                              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                              <line x1="16" y1="2" x2="16" y2="6"></line>
                                              <line x1="8" y1="2" x2="8" y2="6"></line>
                                              <line x1="3" y1="10" x2="21" y2="10"></line>
                                            </svg>
                                            {new Date(blog.date).toLocaleDateString('en-IN', {
                                              day: 'numeric',
                                              month: 'short',
                                              year: 'numeric'
                                            })}
                                          </div>
                                        </div>

                                        <div className="blog-post-content p-4">
                                          <h3 className="text-lg font-semibold">
                                            <Link href={`/blog/${blog.slug}`}>{blog.title}</Link>
                                          </h3>
                                          <span className="text-sm text-gray-500">
                                            By <Link href="#">Admin</Link>
                                          </span>
                                          <p className="mt-2 text-sm text-gray-600 line-clamp-3">
                                            {blog.meta_desc
                                              ? blog.meta_desc.replace(/<[^>]+>/g, '').slice(0, 120)
                                              : ''}
                                          </p>
                                          <Link
                                            className="read-more-btn mt-2 inline-flex items-center text-purple-600 font-medium"
                                            href={`/blog/${blog.slug}`}
                                          >
                                            Read More
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="20"
                                              height="20"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              strokeWidth="2"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              className="ml-1"
                                            >
                                              <line x1="5" y1="12" x2="19" y2="12"></line>
                                              <polyline points="12 5 19 12 12 19"></polyline>
                                            </svg>
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        {/* Right Arrow                   */}
                     	   {/* <div
                                // onClick={currentSlide === totalSlides - 1 ? null : handleNext}
                                onClick={() => handleNext()}
                                className={`swiper-button-next ${
                                  currentSlide === totalSlides - 1
                                    ? 'opacity-50 cursor-not-allowed pointer-events-none'
                                    : ''
                                }`}
                                data-aos="fade-left"
                                data-aos-delay="200"
                                data-aos-duration="500"
                                data-aos-once="true"
                              >
                               </div>
                     */}
                                      <div
                                      onClick={() => handleNext()}
                                      className="swiper-button-next"
                                      data-aos="fade-left"
                                      data-aos-delay="200"
                                      data-aos-duration="500"
                                      data-aos-once="true"
                                    >
                                    </div>
                                 </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="shape1"><Image src="/shape1.svg" alt="shape" loading="lazy" width="202" height="202" decoding="async" data-nimg="1" /></div>
          <div className="shape2 rotateme"><Image src="/shape2.svg" alt="shape" loading="lazy" width="22" height="22" decoding="async" data-nimg="1" /></div>
          <div className="shape3"><Image src="/shape3.svg" alt="shape" loading="lazy" width="28" height="28" decoding="async" data-nimg="1" /></div>
          <div className="shape4"><Image src="/shape4.svg" alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" /></div>
          <div className="shape5"><Image src="/shape5.svg" alt="shape" loading="lazy" width="182" height="146" decoding="async" data-nimg="1" /></div>
          <div className="shape6 rotateme"><Image src="/shape4.svg" alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" /></div>
          <div className="shape7"><Image src="/shape4.svg" alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" /></div>
          <div className="shape8 rotateme"><Image src="/shape2.svg" alt="shape" loading="lazy" width="22" height="22" decoding="async" data-nimg="1" /></div>
        </section>
      </div>
    </div>
              
  );
};

export default Page;